export const GHL_BOOKING_CALENDAR_ID = "dWPXgzMgy3htiFGqP3iF";

export const GHL_BOOKING_URL =
  `https://api.leadconnectorhq.com/widget/booking/${GHL_BOOKING_CALENDAR_ID}`;

export const GHL_BOOKING_IFRAME_ID_PREFIX =
  `${GHL_BOOKING_CALENDAR_ID}_booking_iframe`;
